/**
 * Detects the user's device platform and returns the appropriate app store URL
 */

const APP_STORE_URL = 'https://apps.apple.com/app/id6756345923';
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=app.landtracker';

/**
 * Detects if the user is on an iOS device
 * @returns {boolean} true if iOS device, false otherwise
 */
export const isIOSDevice = () => {
  const userAgent = window.navigator.userAgent.toLowerCase();
  return /iphone|ipad|ipod/.test(userAgent);
};

/**
 * Detects if the user is on an Android device
 * @returns {boolean} true if Android device, false otherwise
 */
export const isAndroidDevice = () => {
  const userAgent = window.navigator.userAgent.toLowerCase();
  return /android/.test(userAgent);
};

/**
 * Gets the appropriate app store URL based on the user's device
 * Falls back to Play Store URL if device is not iOS
 * @returns {string} App store URL
 */
export const getAppStoreURL = () => {
  if (isIOSDevice()) {
    return APP_STORE_URL;
  }
  // Fallback to Android Play Store for all other devices
  return PLAY_STORE_URL;
};

/**
 * Gets the appropriate download button text based on device
 * @returns {string} Button text
 */
export const getDownloadButtonText = () => {
  if (isIOSDevice()) {
    return 'Download on App Store';
  }
  if (isAndroidDevice()) {
    return 'Get it on Google Play';
  }
  return 'Download App';
};

export { APP_STORE_URL, PLAY_STORE_URL };
